<template>
    <section>
        <plan-list type="WEEKPLAN" :is_manage=false></plan-list>
    </section>
</template>

<script>
import planList from "@/components/plan/list"
export default {
    data () {
        return{
            
        }
    },
    components:{planList},

    methods:{
       
    },
    mounted(){
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/plan/week/index.vue